import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Auth0Service } from "../auth0.service";

@Component({
  selector: "app-auth0-select-user",
  templateUrl: "./auth0-select-user.component.html",
  styleUrls: ["../sso/sso.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Auth0SelectUserComponent implements OnInit {

  constructor(
    private readonly authService: Auth0Service
  ) {}

  ngOnInit(): void {
    this.authService.getUser().subscribe({
      next: () => {
        console.log("Auth0 → backend bridge complete");
      },
      error: err => {
        if (err.status === 404) {
          console.warn("GET /me not implemented yet");
        } else {
          console.error("Auth0 login bridge failed", err);
        }
      },
    });
  }
}
